var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Directive, ElementRef, EventEmitter, HostListener, Inject, Input, Output, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
var defaultUtilScript = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.1/js/utils.js';
var Ng2TelInput = /** @class */ (function () {
    function Ng2TelInput(el, platformId) {
        this.el = el;
        this.platformId = platformId;
        this.ng2TelInputOptions = {};
        this.hasError = new EventEmitter();
        this.ng2TelOutput = new EventEmitter();
        this.countryChange = new EventEmitter();
        this.intlTelInputObject = new EventEmitter();
    }
    Ng2TelInput.prototype.ngOnInit = function () {
        var _this = this;
        if (isPlatformBrowser(this.platformId)) {
            this.ng2TelInputOptions = __assign({}, this.ng2TelInputOptions, { utilsScript: this.getUtilsScript(this.ng2TelInputOptions) });
            this.ngTelInput = window.intlTelInput(this.el.nativeElement, __assign({}, this.ng2TelInputOptions));
            this.el.nativeElement.addEventListener("countrychange", function () {
                _this.countryChange.emit(_this.ngTelInput.getSelectedCountryData());
            });
            this.intlTelInputObject.emit(this.ngTelInput);
        }
    };
    Ng2TelInput.prototype.onBlur = function () {
        var isInputValid = this.isInputValid();
        if (isInputValid) {
            var telOutput = this.ngTelInput.getNumber();
            this.hasError.emit(isInputValid);
            this.ng2TelOutput.emit(telOutput);
        }
        else {
            this.hasError.emit(isInputValid);
        }
    };
    Ng2TelInput.prototype.isInputValid = function () {
        return this.ngTelInput.isValidNumber();
    };
    Ng2TelInput.prototype.setCountry = function (country) {
        this.ngTelInput.setCountry(country);
    };
    Ng2TelInput.prototype.getUtilsScript = function (options) {
        return options.utilsScript || defaultUtilScript;
    };
    __decorate([
        Input('ng2TelInputOptions'),
        __metadata("design:type", Object)
    ], Ng2TelInput.prototype, "ng2TelInputOptions", void 0);
    __decorate([
        Output('hasError'),
        __metadata("design:type", EventEmitter)
    ], Ng2TelInput.prototype, "hasError", void 0);
    __decorate([
        Output('ng2TelOutput'),
        __metadata("design:type", EventEmitter)
    ], Ng2TelInput.prototype, "ng2TelOutput", void 0);
    __decorate([
        Output('countryChange'),
        __metadata("design:type", EventEmitter)
    ], Ng2TelInput.prototype, "countryChange", void 0);
    __decorate([
        Output('intlTelInputObject'),
        __metadata("design:type", EventEmitter)
    ], Ng2TelInput.prototype, "intlTelInputObject", void 0);
    __decorate([
        HostListener('blur'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Ng2TelInput.prototype, "onBlur", null);
    Ng2TelInput = __decorate([
        Directive({
            selector: '[ng2TelInput]',
        }),
        __param(1, Inject(PLATFORM_ID)),
        __metadata("design:paramtypes", [ElementRef, String])
    ], Ng2TelInput);
    return Ng2TelInput;
}());
export { Ng2TelInput };
//# sourceMappingURL=ng2-tel-input.js.map